export default "__VITE_ASSET__6f114eb9__"